export default __webpack_public_path__ + "static/media/mainBgMobile.e4b8da0c.png";